export default __webpack_public_path__ + "static/media/danger-sign-handv.433d978c.svg";